/**
 * Conversion heures ↔ jours (métier Synotis).
 *
 * 1 jour = 8h fixe (cohérent avec la capacité dashboard/reports backend).
 * Les taux restent STOCKÉS à l'heure en base ; on saisit/affiche en journalier
 * (TJM/CJM = CHF/jour). Conversion uniquement à la frontière UI : ÷8 au save,
 * ×8 à l'affichage.
 */

export const HOURS_PER_DAY = 8;

/** Heures → jours (équivalent jours). */
export function hoursToDays(hours) {
  const n = Number(hours);
  return Number.isFinite(n) ? n / HOURS_PER_DAY : 0;
}

/** TJM/CJM saisi (CHF/jour) → taux horaire à stocker (÷8). Renvoie '' si vide. */
export function tjmToHourly(tjm) {
  if (tjm === null || tjm === undefined || String(tjm).trim() === '') return '';
  const n = Number(tjm);
  if (!Number.isFinite(n)) return '';
  return String(n / HOURS_PER_DAY);
}

/** Taux horaire stocké → TJM/CJM (CHF/jour) pour affichage (×8). Renvoie '' si vide. */
export function hourlyToTjm(hourly) {
  if (hourly === null || hourly === undefined || String(hourly).trim() === '') return '';
  const n = Number(hourly);
  if (!Number.isFinite(n)) return '';
  return String(n * HOURS_PER_DAY);
}

/** Formatte un taux horaire stocké en TJM (CHF/jour) lisible. */
export function formatTjm(hourly) {
  if (hourly === null || hourly === undefined || String(hourly).trim() === '') return '—';
  const n = Number(hourly);
  if (!Number.isFinite(n)) return '—';
  return `${(n * HOURS_PER_DAY).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} CHF/j`;
}
